<h2 class="dashboard-subheading">{{ 'campaigns.workers.TITLE' | translate }}</h2>
<app-campaigns-workers></app-campaigns-workers>
<div class="mt-4 d-flex justify-content-between">
    <button mat-flat-button color="primary" class="btn" type="button" (click)="changeSection.emit('summary')">
        {{ 'campaigns.workers.ZONES' | translate }}
    </button>
    <button mat-flat-button color="primary" class="btn" type="button" (click)="createCampaign()">
        {{ 'general.actions.PLAN' | translate }}
    </button>
</div>